import React, { useEffect } from 'react';
import ripple from 'ripple-effects';

const RippleInitializer = () => {
  useEffect(() => {
    const applyRipple = () => {
      document.querySelectorAll('.buttonripple,  .ourstorytwo .slick-prev, .ourstorytwo .slick-next , .whiteripple , .textfixed').forEach((el) => {
        if (!el.dataset.rippleApplied) {
          const rippleColor = el.classList.contains('whiteripple') ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)';
          const ripplewidth = el.classList.contains('whiteripple') ? '200svh' : '100vh';

          ripple(el, { 
            background: rippleColor, 
            zIndex: 99, 
            center: true, 
            duration: "600", 
            width: ripplewidth,
            height: "180svh",
            outDuration:"150",
            radius: Math.max(el.clientWidth, el.clientHeight) / 2, 
          });
          el.dataset.rippleApplied = true; 
        }
      });
    };

    applyRipple();

    const observer = new MutationObserver(() => {
      applyRipple();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return null;
};

export default RippleInitializer;
